import { useCallback } from 'react'

export const useNativeNotification = () => {
  const createNotification = ({ title, body, onClick, onClose }) => {
    const options = {
      icon: `/btime-logo-circle-white.png`,
      badge: `/btime-logo-circle-white.png`,
      requireInteraction: true,
      body
    }
    const notification = new Notification(title, options)
    notification.onclick = onClick
    notification.onclose = onClose

    return notification
  }

  const notify = useCallback(({ title, body, onClick, onClose }) => {
    if (!('Notification' in window)) {
      console.log('[NATIVE NOTIFICATION] Este navegador não suporta notificações.')
    } else if (Notification.permission === 'granted') {
      console.log('[NATIVE NOTIFICATION] Permissão para notificações concedida.')
      return createNotification({ title, body, onClick, onClose })
    } else if (Notification.permission !== 'denied') {
      console.log('[NATIVE NOTIFICATION] Permissão para notificações não respondida. Solicitando permissão.')
      Notification.requestPermission().then(permission => {
        if (permission === 'granted') {
          console.log('[NATIVE NOTIFICATION] Permissão para notificações concedida.')
          return createNotification({ title, body, onClick, onClose })
        } else {
          console.log('[NATIVE NOTIFICATION] Permissão para notificações não concedida.')
        }
      })
    }
  }, [])

  return { notify }
}
